var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasRecords),expression:"hasRecords"}],staticClass:"right",attrs:{"page-size":_vm.records,"background":"","current-page":_vm.page,"layout":"sizes, prev, pager, next","page-sizes":[
    50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
  ],"total":_vm.total},on:{"current-change":_vm.fetch,"size-change":_vm.change,"update:currentPage":function($event){_vm.page=$event},"update:current-page":function($event){_vm.page=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }